var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaintenaceNoteUpdate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99969 3.33303V1.47303C7.99969 1.17303 7.63969 1.02636 7.43303 1.23969L4.89969 3.76636C4.76636 3.89969 4.76636 4.10636 4.89969 4.2397L7.42636 6.76636C7.63969 6.97303 7.99969 6.82636 7.99969 6.52636V4.66636C10.4864 4.66636 12.453 6.94636 11.9064 9.52636C11.593 11.0397 10.3664 12.2597 8.85969 12.573C6.47969 13.073 4.35969 11.4397 4.03969 9.23303C3.99303 8.91303 3.71303 8.66636 3.38636 8.66636C2.98636 8.66636 2.66636 9.0197 2.71969 9.4197C3.13303 12.3464 5.91969 14.513 9.07303 13.8997C11.153 13.493 12.8264 11.8197 13.233 9.73969C13.893 6.31969 11.293 3.33303 7.99969 3.33303Z",
    fill: "#202223"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenaceNoteUpdate);
export default __webpack_public_path__ + "static/media/MaintenaceNoteUpdate.34dd8e81a2127dbedac8238c75fa295e.svg";
export { ForwardRef as ReactComponent };